import Logger from '../../utils/Logger';
let { id: module_id } = module;
const logger = new Logger(module_id);

const createActionName =
  require('../util').createActionName('careconversations');

export const RECEIVE_UNREAD_MESSAGE_COUNT = createActionName(
  'RECEIVE_UNREAD_MESSAGE_COUNT'
);

export const GET_UNREAD_MESSAGE_COUNT = createActionName(
    'GET_UNREAD_MESSAGE_COUNT'
);

export const GET_UNREAD_MESSAGE_COUNT_FAILED = createActionName(
    'GET_UNREAD_MESSAGE_COUNT_FAILED'
);

export const getUnreadMessageCount = () => ({
  type: GET_UNREAD_MESSAGE_COUNT,
});

export const receiveUnreadMessageCount = (data) => ({
    type: RECEIVE_UNREAD_MESSAGE_COUNT,
    payload: data,
});

export const getUnreadMessageCountFailed = (error) => ({
    type: GET_UNREAD_MESSAGE_COUNT_FAILED,
    payload: { error },
});

export const doGetCareConversationMessageUnreadCount = () => (dispatch, getState, services) => {
    return new Promise((resolve, reject) => {
        dispatch(getUnreadMessageCount());
        services.api
            .getCareConversationMessageUnreadCount()
            .then((data) => {
                return resolve(dispatch(receiveUnreadMessageCount(data)));
            })
            .catch((err) => {
                console.error(err);
                return reject(dispatch(getUnreadMessageCountFailed(err)));
            });
    });
};
